module.exports = __webpack_public_path__ + "img/colleges_bg_down.48938f79.png";